import React, {Component} from 'react';
import './FormResults.css';
import { evtTrack } from '../utils/analytics';
import Spinner from './Spinner';
import { indefiniteArticle } from '../helpers/grammar/grammar';

class FormResults extends Component {

  asEpLink = 'https://watch.gameshownetwork.com/episodes/d200b6a0-cad5-11ea-9412-3d4951446473/play';
  ckEpLink = 'https://watch.gameshownetwork.com/episodes/76c492c0-cb84-11ea-b197-2394d79010cf/play';
  asEpText = 'episode of America Says';
  ckEpText = 'episode of Common Knowledge';
  alexaClaimFormLink = 'https://forms.gle/QwgX4tDnn1BqZi5Z7';
  giftBoxClaimFormLink = 'https://forms.gle/LfrPELQwiPp7Py5h9';

  getPrize() {
    const prizeId = this.props.message.success;
    let prize = <a href={this.ckEpLink} target="_blank" rel="noopener noreferrer">Free Full Episode</a>;

    switch (prizeId) {
      case 'prize-asep':
        prize = <a href={this.asEpLink} target="_blank" rel="noopener noreferrer">Free Full Episode</a>;
        return this.formatEpPrize(prize, prizeId, this.asEpLink);
      case 'prize-alexa':
        prize = 'Alexa';
        return this.formatPhysicalPrize(prize, prizeId, this.alexaClaimFormLink, this.ckEpText);
      case 'prize-giftbox':
        prize = 'Gift Box';
        return this.formatPhysicalPrize(prize, prizeId, this.giftBoxClaimFormLink, this.asEpText);
      default:
        return this.formatEpPrize(prize, prizeId, this.ckEpLink);
    }

  }

  formatEpPrize(prize, prizeId, link) {

    return (
      <div className={"prize-container " + prizeId}>
        <p className="prize-heading">Instant Winner! <br /> Congrats you won...</p>
        <a href={link} className="prize-logo"></a>
        <p className="prize gotham-ultra">{prize}</p>
        <a href={link} className="prize-host"></a>
        <p className="prize-instructions">You're also entered for a chance to win the  $500 Grand Prize!</p>
      </div>
    )
  }

  formatPhysicalPrize(prize, prizeId, link, linkText) {

    return (
      <div className={"prize-container " + prizeId}>
        <p className="prize-heading">Instant Winner! Congrats, you won {indefiniteArticle(prize)}</p>
        <p className="prize-logo"></p>
        <p className="prize gotham-ultra">{prize}</p>
        <a href={link} target="_blank" className="claim-button">Claim Your Prize!</a>
        <a href={link} target="_blank" className="prize-host"></a>
        <p className="prize-instructions">You're also entered for a chance to win the  $500 Grand Prize!</p>
      </div>
    );
  }

  renderResults() {
    const {
      status,
      message
    } = this.props;

    if (message !== null) {
      if (status === 200) {

        if (message.success !== undefined) {
          evtTrack('25daysofchristmas2020-sweeps-submit-success');
          window.location = '#logo';
          return (
            <div className="spinner-container">
              <Spinner />
              {this.getPrize()}
            </div>
          );
        } else {
          evtTrack('25daysofchristmas2020-sweeps-submit-error200');
          return <p>You ran into error code 200.  Please try again later.  If this keeps happening, please email <a href="mailto:TVHelp@GameShowNetwork.com">TVHelp@GameShowNetwork.com</a> with your error code.</p>
        }
      }

      if (status === 400) {
        switch (message.status) {
          case 407:
            evtTrack('25daysofchristmas2020-sweeps-submit-already');
            return <p className="already-entered">You’re already entered into the sweepstakes. Check out our <a href={this.asEpLink} target="_blank">full episodes of America Says</a></p>
          default:
            evtTrack('25daysofchristmas2020-sweeps-submit-error-'+message.status);
            return <p>You ran into error code {message.status}.  Please try again later.  If this keeps happening, please email <a href="mailto:TVHelp@GameShowNetwork.com">TVHelp@GameShowNetwork.com</a> with your error code.</p>
        }
      }

      evtTrack('25daysofchristmas2020-sweeps-submit-error-unexpected');
      return <p>You ran into an unexpected error.  Please try again later.  If this keeps happening, please email <a href="mailto:TVHelp@GameShowNetwork.com">TVHelp@GameShowNetwork.com</a> with your error code.</p>
    }
  }

  render() {
    const divStyle = {
      minHeight:this.props.data.panelHeight
    }
    return (
      <div className="submission-results" style={divStyle}>
        {this.renderResults()}
      </div>
    );
  }
}

export default FormResults;